import { Component } from '@angular/core';

@Component({
  selector: 'glxy-chat-divider-text',
  templateUrl: './chat-divider-text.component.html',
  styleUrls: ['./chat-divider-text.component.scss'],
})
export class ChatDividerTextComponent {}
